// Brand: Milano
// Flow: PreOrder

import React from 'react';

import withAppState from '../../../mobx/withAppState'

import PreOrderRestaurantSearch from '../../../components/PreOrderRestaurantSearch';
import { Steps } from '../../../lib/constants';

import milogo from '../../../assets/milano/milano-logo-header.svg';

const RestaurantSearchWrapper = props => {
  const handleRestaurantSelect = (restaurant) => {
    props.selectRestaurant(restaurant);
    
    if(!props.isCheckInJourney){
      props.goToStep(Steps.PRE_ORDER);
    }
    else{
      if (props.getDataCaptureStatusForCurrentRestaurant() === true) props.goToStep(Steps.PRE_ORDER);
     else props.goToStep(Steps.PRE_ORDER_DATA_CAPTURE);

    }

  }

  const logo = (
      <a href="https://milano.ie/">
        <img src={milogo} alt="Milano" />
      </a>
  )

  return (<PreOrderRestaurantSearch logo={logo} handleRestaurantSelect={handleRestaurantSelect}>
    {props.isCheckInJourney &&
    <p>Select your restaurant, browse away, click on your favourite dishes to add to your basket as a reminder, then call us over and we'll take your order.</p>}
  </PreOrderRestaurantSearch>);
}

export default withAppState(RestaurantSearchWrapper,
    {
        mobXActions: ({
            getDataCaptureStatusForCurrentRestaurant,
            selectRestaurant,
            goToStep,
        }) => ({
            getDataCaptureStatusForCurrentRestaurant,
            selectRestaurant,
            goToStep,
        }),
        mobXProps: ({
            isCheckInJourney
        }) => ({
            isCheckInJourney
        })

  }
);